<div class="main-content-container">
  <div class="main-container-body">
    <div class="page-title-container d-flex">
      <div class="page-title">
        <div class="mb-0">
          <div class="d-flex align-items-center">
            <!-- <div class="pr-2">
            <a class="d-inline-flex" href="javascript:void(0)" (click)="goBack()">
              <img src="assets/images/grid-back.png" />
            </a>
          </div> -->
          <div>
            Assessment Engine
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-container">
    <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
      <label for="additionalsurgeryName" id="additionalsurgeryName">Assessment Templete</label>
      <kx-multiselect-dropdown [questions]="assessmentQues"
        [placeholder]="'Select item'" [data]="assessmentQues.datasource" [settings]="assessmentQues.defaultsetting"
        [disabled]="false" (onDeSelect)="onDeSelect($event)" (onSelect)="onItemSelect($event)" >
      </kx-multiselect-dropdown>
    </div>
    @if (assessment_template_id) {
      <div class="col-12">
        <!-- <app-assessment-form *ngIf="questions != null" [assessment_template_id]="assessment_template_id" [questions]="questions"></app-assessment-form> -->
        @if (_currentData.currentFormFields != null) {
          <dhs-form [action]="_currentData.currentAction" [fieldGroup]="_currentData.currentFormFields" [config]="config" [decorator]="this._currentData.currentFormFields.decorator"  #formComponenet></dhs-form>
        }
      </div>
    }
  </div>
</div>
</div>